import { useState } from 'react';

export default function Card({ children, styles }) {
    const cardStyles = {
        borderRadius: '6px',
        width: '200px',
        minHeight: '50px',
        cursor: 'pointer',
        border: '1px solid #314158',
        padding: '10px',
        transition: 'all 0.2s ease-in-out',
        backgroundColor: '#1a1a1a',
    }

    const [isHovered, setIsHovered] = useState(false);

    const hoverStyles = isHovered ? {
        border: '1px solid #8e51ff',
        backgroundColor: '#2a2a2a',
    } : {};

    return (
        <div 
            style={{ ...cardStyles, ...hoverStyles, ...styles }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {children}
        </div>
    )
}